import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
  BerthVisit,
  BezoekschipOrganisation,
  Exemption,
  ExemptionReferenceData
} from '@portbase/bezoekschip-service-typescriptmodels';
import {AppContext} from 'src/app/app-context';
import {VisitContext} from '../../../../visit-context';
import {uploadExemptionAttachments} from '../exemptions_attachments/exemptions.attachments';
import {deleteExemptionAttachment} from '../exemptions_attachments/exemptions.attachments';
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";
import {uuid} from "../../../../../common/utils";

@Component({
  selector: 'app-visit-exemptions',
  templateUrl: './exemptions.component.html',
  styleUrls: ['./exemptions.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExemptionsComponent implements OnInit {

  visitContext = VisitContext;
  appContext = AppContext;

  organisation: BezoekschipOrganisation;

  uploadedExemptionFileName: string;
  uploadedExemptionFileContent: string;

  index: number;

  @Input() berthVisit : BerthVisit;
  @Input() exemptions : { [index: string]: Exemption };

  onBehalfOfOptions: string[] = [
    "Captain",
    "Skipper",
    "Operator",
    "Owner",
    "Terminal",
    "Natural Person",
    "Other",
  ]

  ngOnInit() {

    this.organisation = this.appContext.userProfile.organisation;

    if (this.visitContext.visit.visitDeclaration.exemptions == null) {
      this.visitContext.visit.visitDeclaration.exemptions = {};
    }

    if (this.exemptions && this.exemptions[this.index] == null) {
      this.exemptions[this.index] = {};
      this.exemptions[this.index].company = AppContext.userProfile.organisation.fullName;
    }

    if (this.exemptions && this.exemptions[this.index].company == null) {
      this.exemptions[this.index].company = "";
    }
  }

  upload = uploadExemptionAttachments;
  delete = deleteExemptionAttachment;

  get showGeneralInformation(): boolean {
    return this.berthVisit.selectedExemptionTypes?.length > 0 && this.berthVisit.selectedExemptionTypes[0] != null;
  }

  showExemption(index: number): boolean {
    return this.berthVisit.selectedExemptionTypes[index] != null
  }

  setSelectedExemptionIndex(index: number) {
    this.index = index;
  }

  getConsidering(index: number): string {
    return this.berthVisit.selectedExemptionTypes[index].applicableMunicipalities
      .find(m => m.code == this.berthVisit?.berth?.municipalityUnlocode)?.considering || ""
  }

  getName(index: number): string {
    return this.berthVisit.selectedExemptionTypes[index].name;
  }

  protected readonly refData = PortvisitUtils;

  hasExemptions(): boolean {
    return this.berthVisit.selectedExemptionTypes?.length > 0;
  }

  getExemptions() {
    return this.berthVisit?.selectedExemptionTypes.filter(exemption => exemption != null) || []
  }

  getExemptionFor(exemptionReferenceData: ExemptionReferenceData) {
    const currentExemption = Object.values(this.visitContext.visit.visitDeclaration.exemptions).find(value =>
      value.exemptionType == exemptionReferenceData.exemptionType && value.berthVisitId == this.berthVisit.id
    )
    if (currentExemption) {
      return currentExemption;
    }
    const newExemption = this.createNewExemption(exemptionReferenceData.exemptionType);
    this.visitContext.visit.visitDeclaration.exemptions[newExemption.id] = newExemption;

    return newExemption;
  }

  createNewExemption(exemptionType: string): Exemption {
    let result = {
      id: uuid(),
      exemptionType : exemptionType,
      index : this.index,
      berthVisitId : this.berthVisit.id,
      attachments : [],
      company : this.organisation?.fullName,
      addressOfApplicant : this.organisation?.address + ', ' +
        this.organisation?.zipCode + ', ' +
        this.organisation?.city + ', ' +
        this.organisation?.countryName
    };
    if (exemptionType == "Exemption Debunkering") {
      result["bunkerItem"] = {};
    }
    return result;
  }
}
